// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"576d7943","475":"21885301","625":"272ce6c2"}[chunkId] + ".chunk.css";
};